<template>
    <div id="bene-province-postcode-container">
      <f7-list form class="form-group" v-if="showFormSet.provinceDetails">
          <f7-list-input
              input-id     ="postcode"
              name         ="postcode"
              type         ="number"

              v-if         ="showFormInput.provinceDetails.postcode"
              :label       ="postcodeLabel"
              :placeholder ="postcodeLabel"
              :value       ="postcode"
              @change      ="setPostcode($event.target.value); validateInput($event.target); setInput($event.target)"

              autocomplete ="off"
              maxlength    ="15"
              outline
              floating-label
              clear-button
          ></f7-list-input>
      </f7-list>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {

    },
    mounted (){
      // console.log("provinceList: ", this.provinceList)
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('beneficiary', [
          'showFormSet',
          'showFormInput',
          'street',
          'streetLabel',
          'postcode',
          'showPreloaderState',
          'postcodeLabel'
      ])
    },
    methods: {
      ...mapActions('beneficiary', [
          'setStreet',
          'setPostcode',
          'setShowPreloaderState',
      ]),

      validateInput(inputEl){
        this.showPreloader();
        this.$emit("validateInput", inputEl);
        this.hidePreloader();
      },

      setInput(inputEl){
        this.$emit("setInput", inputEl);
      }
    }
  }
</script>